import { AuthContext } from "@/contexts/AuthContext";
import { SiTwitch } from "@icons-pack/react-simple-icons";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const HomePage: React.FC = () => {
    const { startTwitchLogin, isAuthenticated, loading } =
        useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        // If user is already authenticated, redirect to dashboard
        if (!loading && isAuthenticated) {
            navigate("/dashboard");
        }
    }, [isAuthenticated, loading, navigate]);

    // Show loading state while checking authentication
    if (loading) {
        return (
            <div className="flex min-h-screen w-full items-center justify-center">
                <div className="flex flex-col items-center gap-4">
                    <div className="h-12 w-12 animate-spin rounded-full border-4 border-amber-500 border-t-transparent"></div>
                    <p className="text-sm text-slate-300">Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="relative flex min-h-screen w-full items-center justify-center px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl text-center">
                <div className="mb-6">
                    <h2
                        className="font-norse text-brand text-7xl leading-tight drop-shadow-lg lg:text-8xl xl:text-9xl"
                        style={{
                            WebkitTextStroke: "3px black",
                        }}
                    >
                        The Vanderheim Village
                    </h2>
                </div>
                <button
                    className="mx-auto flex items-center justify-center rounded-md bg-[#6441A4] px-6 py-3 text-lg font-semibold text-white sm:text-xl"
                    onClick={startTwitchLogin}
                >
                    <SiTwitch className="mr-2 inline-block text-xl sm:text-2xl" />
                    Login with Twitch
                </button>
            </div>
        </div>
    );
};

export default HomePage;
